import ObjectiveCard from './ObjectiveCard';

export default ObjectiveCard;
